import Fonts from '../../../../shared/assets/style/default/fonts';
import styled from 'styled-components';
import Colors from '../../../../shared/assets/style/default/color';

const Focal = styled.span<React.CSSProperties>`
  color: ${Colors.modal.title};
  font-family: ${Fonts['bold']};
`;

export default Focal;
